import React from 'react';
import { ModalV2 } from '@dapp/multi-lib/ui/V2Modal';
import { TeamData } from 'structure/home/components/FoundationTeam/types';
import Image from 'next/image';
import { Body1, Body2, Header5 } from 'structure/home/components/Typography';

interface ModalMenuProps {
  open: boolean;
  item: TeamData;
  onOpenChange: (open: boolean) => void;
}

export const TeamModal = (props: ModalMenuProps) => {
  const { open, item, onOpenChange } = props;

  if (!item) {
    return null;
  }

  return (
    <ModalV2.Root open={open} onOpenChange={onOpenChange}>
      <ModalV2.Content
        variant='transparent'
        scrollable
        className='w-full justify-center focus-visible:outline-0'
      >
        <ModalV2.Body
          variant='unstyled'
          className='ml-auto mr-auto w-full max-w-[380px] px-4 py-4 focus-visible:border-0 lg:max-w-[600px]'
        >
          <div className='rounded-main relative flex max-h-[600px] flex-col gap-4 overflow-y-auto border border-[#D9D9D9]/40 bg-black px-6 pb-10 pt-4 lg:px-10'>
            <ModalV2.Close />
            <div className='flex h-[144px] w-[144px] justify-center self-center rounded-full bg-white'>
              <Image
                src={item.img}
                alt='teamImage'
                className='rounded-full'
                width={144}
                height={144}
              />
            </div>
            <div className='flex flex-col'>
              <Header5 className='font-normal'>{item.name}</Header5>
              <Body2>{item.position}</Body2>
            </div>

            <Body1 className='text-[1rem]'>{item.designation}</Body1>
          </div>
        </ModalV2.Body>
      </ModalV2.Content>
    </ModalV2.Root>
  );
};
